import { Box, Paper as MuiPaper, Button, Card, CardActions, Collapse, Divider, IconButton, MenuItem, Select, SelectChangeEvent, Typography, Tooltip, Popover, TextField } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import Paper, { PaperProps, SCHOLAR_INBOX_PAPERS_URL, generateBibtex } from './Paper';
import { GetCollectionPaperData } from '../services/DigestService';
import responseSetPaperProps from '../utils/setPaperPropsUtils';
import { mockDigestData } from '../services/mockServiceData';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import TripleDotLoadingProgress from './tools/TripleDotLoadingProgress';
import { FeatureToggle } from '../pages/settings/FeatureToggleSettingsPage';
import PaperPreview from './PaperPreview';
// import { handle } from 'mdast-util-to-markdown/lib/handle';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import { scrollAfterAdditionalLoading } from '../pages/CollectionsPage';


export interface collectionPapersPairs {
    collectionName: string;
    paperId: number;
}

export interface CollectionTabProps {
  collection: string;
  expanded: boolean;
  collectionId: number;
  allUserCollections: string[];
  featureToggles: FeatureToggle[];
  sortMode: string;
  compactPapersMode: boolean;
  updateChangedPapers?: (collectionName: string, paperId: number,) => void;
  papersToExclude?: collectionPapersPairs[];
}


function sortCollectionPapers(
  papers: PaperProps[],
  sortBy: string,
  sortOrder: string,
): PaperProps[] {
  let sortedPapers = [...papers];

  switch (sortBy) {
    case 'title':
      sortedPapers.sort((a, b) => {
        if (a.title < b.title) {
          return 1;
        }
        if (a.title > b.title) {
          return -1;
        }
        return 0;
      });
      break;
    case 'collection_addition_date':
      sortedPapers.sort((a, b) => {
        return new Date(a.collectionAdditionDate || '') > new Date(b.collectionAdditionDate || '') ? 1 : -1;
      });
      break;
    case 'relevance':
      sortedPapers.sort((a, b) => (b.relevance || 0) - (a.relevance || 0));
      break;
    case 'title':
      sortedPapers.sort((a, b) => (a.title || '').localeCompare(b.title || ''));
      break;
    default:
      break;
  }

  if (sortOrder === 'desc' && sortBy !== 'relevance') {
    sortedPapers.reverse();
  }
  if (sortOrder === 'asc' && sortBy === 'relevance') {
    sortedPapers.reverse();
  }

  return sortedPapers;
}

const generateBibtexForSetOfPapers = (papers: PaperProps[]) => {
  let bibtex = '';
  papers.forEach(paper => {
    const paperBibtex = generateBibtex(paper);
    bibtex += paperBibtex + '\n\n';
  }
  );
  return bibtex;
}


export function UpdateCollectionTab(mode: String = "add_collection", collection: String, paper_id: String, is_new_collection: boolean) {
    // mode: "add_collection" or "remove_collection"

    //todo: update the collection tab feed directly, not by clicking on the tab...
    // check current url and reload the added collection tab if it is the collections page
    if (window.location.pathname === '/collections') {
        const collTabId = "coll-tab-" + collection;
        const collTab = document.getElementById(collTabId);
        // reload the collection tab if it was open (save scroll position and page height before reload)
        const savedScroll = window.scrollY;
        const pageHeightBeforeLoad = document.documentElement.scrollHeight;
        if (collTab) {
            // get the bounding box of the collection box and a paper box
            const collBoxRect = document.getElementById("coll-box-" + collection).getBoundingClientRect();
            const paperRect = document.getElementById("paper" + paper_id.toString()).getBoundingClientRect();
            // check if collection is expanded (if not - do nothing)
            if (collBoxRect.height > 100) {
                // close collection tab
                collTab.click();
                // check if collection is above (if not - do not scroll)
                if (collBoxRect.top < 0) { window.scrollTo(0, savedScroll - collBoxRect.height); }
                console.log('window pos1', window.scrollY, savedScroll - collBoxRect.height);
                // wait for the page to reload to open the collection tab again
                setTimeout(() => {
                    var element = document.getElementById(collTabId);
                    if (element) {
                        element.click();
                        console.log('window pos2', window.scrollY, savedScroll, savedScroll + paperRect.height, document.documentElement.scrollHeight);
                        if (collBoxRect.top < 0) {
                            // scroll to previous position
                            if (mode === "add_collection") {
                                scrollAfterAdditionalLoading(savedScroll + paperRect.height, pageHeightBeforeLoad, 200);
                            } else {
                                scrollAfterAdditionalLoading(savedScroll - paperRect.height, pageHeightBeforeLoad, 200);
                            }
                        }
                    } else {
                        console.log('element not found');
                    }
                }, 400);
            }
        }
        if (is_new_collection) {
            console.log('New collection created');
            window.location.reload();
            // todo: fix the scrolling back to the position after reload
        };
    }
}



export default function CollectionTab(props: CollectionTabProps) {
  const [showCollectionPapers, setShowCollectionPapers] = useState(true);  // props.expanded
  const [showBibtex, setShowBibtex] = useState(false);
  const [bibtexString, setBibtexString] = useState('');
  const [bibtexAnchorEl, setBibtexAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const [collectionPapers, setCollectionPapers] = useState<PaperProps[]>([]);
  const [loading, setLoading] = useState(true);
  const collectionTabRef = useRef(null)

  const loadCollectionPapers = (collectionId: number) => {
    const collectionPapersData = GetCollectionPaperData(collectionId);
    collectionPapersData.then(res => {
      handleCollectionPapersFeed(res);
      setLoading(false);
    });
    setLoading(true);
  }

  const handleCollectionPapersFeed = (response) => {
    // guard vs empty response
    if (response == undefined || Object.keys(response).length === 0) {
      setCollectionPapers(mockDigestData);
      return;
    }
    // build digest data
    const digest: PaperProps[] = responseSetPaperProps(response);
    const collectionAdditionDatesList = response.collection_addition_dates;
    digest.map((paper, index) => {
      paper.collectionAdditionDate = collectionAdditionDatesList.filter((collectionAdditionDate) => collectionAdditionDate.paper_id === paper.paperId)[0].addition_date;
    });
    const sortedPapers = sortCollectionPapers(digest, props.sortMode, 'desc');
    setCollectionPapers(sortedPapers);
  };

    const removeCollectionPaper = (paperId: number, collectionName: string) => {
        if (collectionName === props.collection) {
            const updatedFeed = collectionPapers.filter(paper => {
                return paper.paperId !== paperId;
            });
            setCollectionPapers(updatedFeed);
            if (updatedFeed.length === 0) {
                //todo: think of the more smooth update of all collections list later
                // reload the page 
                window.location.reload();
            }
            return false;
        } else {
            if (props.updateChangedPapers) {
                props.updateChangedPapers(collectionName, paperId);      
                props.updateChangedPapers(collectionName, paperId);
            }
            return true;
        }
    }


  const handleCollectionTabClick = (modeToSet: boolean) => { // true = open, false = close
    setShowCollectionPapers(modeToSet);
    if (modeToSet) {
      loadCollectionPapers(props.collectionId);
      // ExpandCollectionTab(props.collectionId);

    } else {
      setLoading(false);
      setCollectionPapers([]);
      // CollapseCollectionTab(props.collectionId);
    }
  };

  const handleBibtexButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!showBibtex) {
      const bibtex = generateBibtexForSetOfPapers(collectionPapers);
      setBibtexString(bibtex);
      setBibtexAnchorEl(event.currentTarget);
      navigator.clipboard.writeText(bibtex);
    }
    setShowBibtex(!showBibtex);
    // fire zotero event to ping extension that we've updated metadata
    document.dispatchEvent(new Event('ZoteroItemUpdated', {
      bubbles: true,
      cancelable: true
    }));
  };

  const handleBibtexDownload = (e: React.MouseEvent<HTMLButtonElement>) => {
    const bibtex = generateBibtexForSetOfPapers(collectionPapers);
    const element = document.createElement('a');
    const file = new Blob([bibtex], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = props.collection + '.bib';
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };


  useEffect(() => {
    // if (props.expanded) {
    loadCollectionPapers(props.collectionId);
    // console.log("collection tab expanded", props.collectionId)
    // }
  }, []);

  useEffect(() => {
        console.log("usef sort mode", props.sortMode, props.collection,)
    const sortedPapers = sortCollectionPapers(collectionPapers, props.sortMode, 'desc');
    setCollectionPapers(sortedPapers);
  }, [props.sortMode]);

    useEffect(() => {
        console.log("usef papers to exclude", props.collection, props.papersToExclude)
        if (props.papersToExclude) {
            for (let i = 0; i < props.papersToExclude.length; i++) {
                if (props.papersToExclude[i].collectionName === props.collection) {
                    const updatedFeed = collectionPapers.filter(paper => {
                        return paper.paperId !== props.papersToExclude[i].paperId;
                    });
                    setCollectionPapers(updatedFeed);
                }
            }
        }
    }, [props.papersToExclude]);

    return (
        <Box id={"coll-box-" + props.collection.toString()}>
            {/* collection tab with collapsed paperbox */}
            <MuiPaper sx={{ display: 'flex', flexDirection: 'column', m: 1, mb: 1 }} elevation={3}>
                {/* collection bar */}
                <Box id={"coll-tab-" + props.collection.toString()} ref={collectionTabRef} sx={{ display: 'flex', justifyContent: 'left', background: '#D1EAF9', cursor: 'pointer', borderTopLeftRadius: '3px', borderTopRightRadius: '3px' }} onClick={() => handleCollectionTabClick(!showCollectionPapers)}>
                    <Typography variant='h6' sx={{ py: 1, ml: 2, userSelect: "none" }}> {props.collection} </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'row', ml: 'auto', }}>
                        {/* TODO: Make this bibtex usable with zotero as collection(?) */}

            {showCollectionPapers ?
              (<>
                <Tooltip arrow title='Download BibTeX for this paper collection' placement="top">
                  <IconButton sx={{ ml: 'auto', mt: '5px', mr: '1px', width: '1.7em', height: '1.7em', justifySelf: 'end' }} onClick={(e) => { e.stopPropagation(); handleBibtexDownload(e); }}>
                    <SimCardDownloadIcon color='secondary' sx={{ mt: 0.5, transform: 'scale(0.9)' }} />
                  </IconButton>
                </Tooltip>
                <Tooltip arrow title='Copy BibTeX for this paper collection' placement="top">
                  {showBibtex ?
                    <IconButton sx={{ ml: 'auto', mt: '5px', mr: '1px', width: '1.7em', height: '1.7em', justifySelf: 'end' }} onClick={(e) => { e.stopPropagation(); handleBibtexButtonClick(e); }}>
                      <LibraryAddCheckIcon color='secondary' sx={{ mt: 0.5, transform: 'scale(0.9)' }} />
                    </IconButton>
                    :
                    <IconButton sx={{ ml: 'auto', mt: '5px', mr: '1px', width: '1.7em', height: '1.7em', justifySelf: 'end' }} onClick={(e) => { e.stopPropagation(); handleBibtexButtonClick(e); }}>
                      <LibraryAddIcon color='secondary' sx={{ mt: 0.5, transform: 'scale(0.9)' }} />
                    </IconButton>}
                </Tooltip>
                <IconButton sx={{ ml: 'auto', height: '80%', mt: '5px', mr: '1px' }} onClick={() => handleCollectionTabClick(!showCollectionPapers)}><KeyboardArrowUpIcon /></IconButton></>
              ) : (
                <IconButton sx={{ ml: 'auto', height: '80%', mt: '5px', mr: '1px' }} onClick={() => handleCollectionTabClick(!showCollectionPapers)}><KeyboardArrowDownIcon /></IconButton>
              )}
          </Box>
        </Box>
        <Popover
          id={props.collectionId + 'popover'}
          open={showBibtex}
          anchorEl={bibtexAnchorEl}
          onClose={() => { setBibtexAnchorEl(null); setShowBibtex(false); }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          sx={{ maxWidth: '90%', maxHeight: '40%' }}
        >
          <Box sx={{ p: 1, display: 'flex', flexDirection: 'column', }}>
            <Typography variant='body1'>
              This BibTeX has been copied to your clipboard. <br />
              Use CTRL/CMD+V to paste it.
            </Typography>
            <TextField
              color='secondary'
              id={'bibtex-' + props.collectionId + '-textarea'}
              multiline
              defaultValue={bibtexString}
              inputProps={{
                readOnly: true,
                style: {
                  fontFamily: 'Courier',
                  lineHeight: '20px',
                  margin: '-8px' // hack vs mui stubborn padding on root element
                }
              }}
            />
          </Box>
        </Popover>
        <Divider />
        {/* papers from collection */}
        <Collapse in={showCollectionPapers}>
          {loading && (
            <TripleDotLoadingProgress />
          )}
          <Box sx={{ ml: 1, mr: 1, mb: props.compactPapersMode ? 1 : 0, mt: props.compactPapersMode ? 1 : 0, }}>
            {!loading && collectionPapers.length > 0 && (
              collectionPapers?.map(paper => (
                <>{!props.compactPapersMode ? (
                  <Paper {...paper} key={paper.title}
                    all_user_collections={props.allUserCollections}
                    featureToggles={props.featureToggles} 
                    deleteCollectionPaper={removeCollectionPaper}/>) : (
                  <PaperPreview {...paper} key={paper.title}
                    all_user_collections={props.allUserCollections}
                    deleteCollectionPaper={removeCollectionPaper}></PaperPreview>
                )}</>
              )))
            }
          </Box>
        </Collapse>
      </MuiPaper>
    </Box>
  )
};